import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class SkuBulkUploadDataService {
  private skuBulkUploadMetaData = {};
  private fileNameObject = {};
  private selectedKeyAcount: any = {};
  private mandatoryColumnRules: any = [];
  private validationResponse = {};
  private uploadTaskId = "";

  setMandatoryColumnRules(data: any) {
    this.mandatoryColumnRules = data;
  }

  getMandatoryColumnRules() {
    return this.mandatoryColumnRules;
  }

  setSkuBulkUploadMetaData(data: any) {
    this.skuBulkUploadMetaData = data;
  }

  setFileName(data: any) {
    this.fileNameObject = data;
    sessionStorage.setItem("skuBulkUploadData", JSON.stringify(data));
  }

  getFileName() {
    if (Object.keys(this.fileNameObject).length === 0) {
      const data = sessionStorage.getItem("skuBulkUploadData");
      if (data) {
        this.fileNameObject = JSON.parse(data);
      }
    }
    return this.fileNameObject;
  }

  getSkuBulkUploadMetaData() {
    return this.skuBulkUploadMetaData;
  }

  setValidationResponse(data: any) {
    this.validationResponse = data;
  }

  setSelectedKeyAccount(data: any) {
    this.selectedKeyAcount = data;
    sessionStorage.setItem("selectedKeyAccount", JSON.stringify(data));
  }

  getSelectedKeyAccount() {
    if (Object.keys(this.selectedKeyAcount).length === 0) {
      const data = sessionStorage.getItem("selectedKeyAccount");
      if (data) {
        this.selectedKeyAcount = JSON.parse(data);
      }
    }
    return this.selectedKeyAcount;
  }

  getValidationResponse() {
    return this.validationResponse;
  }

  setUploadTaskId(data: any) {
    this.uploadTaskId = data;
  }

  getUploadTaskId() {
    return this.uploadTaskId;
  }
}
